import { __generator } from "tslib";
import React from 'react';
import { call, put, select, take, race } from 'redux-saga/effects';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getCurrentSubfolderId, getGallectionById, getCurrentFolderId, } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { unsetCurrentSubfolderId } from '../actions';
import { request } from '../../xhr';
import { isPremiumGallection, getPremiumGallectionType, } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { TrashCan, PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
function removeGallection(action) {
    var selectedFolderId, mediaSource, currentFolderId, selectedFolder, folderType, currentSubfolderId, streamId, no, data;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                selectedFolderId = action.payload;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                return [4 /*yield*/, select(getGallectionById, selectedFolderId)];
            case 3:
                selectedFolder = _b.sent();
                if (!selectedFolder) {
                    return [2 /*return*/];
                }
                folderType = getPremiumGallectionType(selectedFolder) || 'regular';
                return [4 /*yield*/, select(getCurrentSubfolderId)];
            case 4:
                currentSubfolderId = _b.sent();
                streamId = getGallectionStreamId(mediaSource, currentFolderId);
                if (!isPremiumGallection(selectedFolder)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: folderType === 'paid'
                            ? 'mediapopup.confirmationPopup.removeFolder.title.paid'
                            : 'mediapopup.confirmationPopup.removeFolder.title.watchers',
                        textTransKey: folderType === 'paid'
                            ? 'mediapopup.confirmationPopup.removeFolder.text.paid'
                            : 'mediapopup.confirmationPopup.removeFolder.text.watchers',
                        confirmBtnLabelTransKey: 'mediapopup.itemMenu.delete',
                        cancelBtnLabelTransKey: 'popup.cancel',
                        confirmBtnType: 'danger',
                        icon: React.createElement(PremiumTrash, null),
                    }))];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                    titleTransKey: "mediapopup.confirmationPopup.removeFolder.".concat(selectedFolder.type, ".title"),
                    textTransKey: "mediapopup.confirmationPopup.removeFolder.".concat(selectedFolder.type, ".text"),
                    confirmBtnLabelTransKey: 'mediapopup.itemMenu.delete',
                    cancelBtnLabelTransKey: 'popup.cancel',
                    confirmBtnType: 'danger',
                    icon: React.createElement(TrashCan, null),
                }))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [4 /*yield*/, race({
                    yes: take(confirmYes),
                    no: take(confirmNo),
                })];
            case 9:
                no = (_b.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(actions.deleteItem({ streamId: streamId, item: selectedFolderId }))];
            case 10:
                _b.sent();
                if (!(selectedFolderId === currentSubfolderId)) return [3 /*break*/, 12];
                return [4 /*yield*/, put(unsetCurrentSubfolderId())];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12:
                data = {
                    type: (_a = getGallectionType(mediaSource)) !== null && _a !== void 0 ? _a : 'collection',
                    folderid: selectedFolderId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/delete',
                        data: data,
                    })];
            case 13:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default removeGallection;
//# sourceMappingURL=removeGallection.js.map